import React, { useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import AWS from "aws-sdk";
import toast from "react-hot-toast";
import S3Image from "../S3Image";

export default function AddConfig({
  title,
  show,
  onHide,
  buttonTitle,
  api,
  refresh,
  componentId,
  selectedItem,
}) {
  const [name, setName] = useState(selectedItem?.name || "");
  const [imageUrl, setImageUrl] = useState(selectedItem?.image || "");
  const [nameError, setNameError] = useState("");
  const [image, setImage] = useState(null);
  const [loader, setLoader] = useState(false);
  const s3 = new AWS.S3();

  const handleUpload = async (file) => {
    if (!file) {
      toast.error("Please select an image file.");
      throw new Error("File not selected");
    }

    const params = {
      Bucket: process.env.REACT_APP_PUBLIC_S3_BUCKET_NAME,
      Key: file.name,
      Body: file,
    };

    try {
      const data = await s3.upload(params).promise();
      return data;
    } catch (error) {
      console.error("S3 Upload Error:", error);
      toast.error("Image upload failed. Please try again.");
      throw error;
    }
  };

  const handleAddFormSubmit = async (event) => {
    event.preventDefault();
    if (loader) return;

    let hasError = false;

    // Validate name
    if (name.trim().length < 1) {
      setNameError("Name is required");
      hasError = true;
    } else {
      setNameError("");
    }

    if (hasError) return;

    setLoader(true);

    try {
      let bodyPartImage;

      if (image?.name) {
        bodyPartImage = await handleUpload(image);
      }

      const postData = {
        name: name,
        ...(buttonTitle === "Add" && { componentId }),
        ...(buttonTitle !== "Add" && { categoryId: selectedItem?._id }),
        ...(bodyPartImage?.Location && {
          image: bodyPartImage?.Location,
        }),
        ...(imageUrl && {
          image: imageUrl,
        }),
      };

      await api(postData);

      toast.success(
        buttonTitle === "Add" ? "Added Successfully" : "Edited Successfully"
      );
      refresh(buttonTitle === "Add" ? undefined : componentId);
      onHide(false);
    } catch (error) {
      console.error("API Error:", error);
      toast.error(error?.response?.data?.message || "An error occurred.");
    } finally {
      setLoader(false);
    }
  };

  return (
    <Modal className="sortBy" show={show} onHide={onHide} centered>
      <div className="d-flex justify-content-between align-items-center p-3">
        <h3 className="text-center">{title}</h3>
        <button type="button" className="close" onClick={onHide}>
          <span>×</span>
        </button>
      </div>

      <form onSubmit={handleAddFormSubmit}>
        <div className="form-group p-3">
          <>
            <label className="text-black font-w500">Image</label>
            <div className="contact-name">
              <input
                type="file"
                className="form-control"
                onChange={(e) => {
                  setImage(e.target.files[0]);
                }}
                accept="image/png, image/jpeg"
              />
              {imageUrl && (
                <div className="d-flex justify-content-between p-2">
                  <div style={{ backgroundColor: "black" }}>
                    <S3Image
                      imageKey={imageUrl}
                      type={"Profiles"}
                      fileType={"profile-image"}
                      style={"profile-photo"}
                    />
                  </div>
                  <span
                    className="text-muted"
                    onClick={() => {
                      setImage(null);
                      setImageUrl("");
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    Remove
                  </span>
                </div>
              )}
            </div>
          </>
          <div className="form-group mb-3 mt-4">
            <label className="text-black font-w500">Name</label>
            <input
              className="form-control"
              name="question"
              value={name}
              onChange={(e) => {
                setName(e.target.value);
                setNameError("");
              }}
              placeholder="Name"
            />
            {nameError && <div className="text-danger fs-12">{nameError}</div>}
          </div>
        </div>

        <div className="p-3 d-flex justify-content-end">
          <button
            className="btn btn-sm btn-primary"
            type="submit"
            disabled={loader}
          >
            {loader ? <Spinner animation="border" size="sm" /> : buttonTitle}
          </button>
        </div>
      </form>
    </Modal>
  );
}
